import { IoMdSearch } from 'react-icons/io'
import { useLocation, useNavigate } from 'react-router'
import { useI18n } from '../provider/i18n'

const SearchButton = () => {
  const i18n = useI18n()
  const location = useLocation()
  const navigate = useNavigate()

  const onSearch = () => {
    if (
      location.pathname.startsWith('/tests/search') ||
      location.pathname.startsWith('/shipping-tests/search') ||
      location.pathname.startsWith('/consultation/search') ||
      location.pathname.startsWith('/training/search')
    ) {
      return
    }
    if (
      location.pathname === '/tests' ||
      location.pathname.startsWith('/tests/tag')
    ) {
      navigate('/tests/search')
    } else if (
      location.pathname === '/shipping-tests' ||
      location.pathname.startsWith('/shipping-tests/tag')
    ) {
      navigate('/shipping-tests/search')
    } else {
      const pathName = `${location.pathname}/`
      navigate(`${pathName}search`)
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <button
        className="flex items-center border border-border border-solid border-opacity-50 px-1.5 py-2.5 rounded-lg gap-2"
        onClick={onSearch}
      >
        <div className="h-full flex items-center justify-center ml-[1px]">
          <IoMdSearch size={24} color="#000" />
        </div>
        <span className="text-lg text-gray-500">
          {i18n.t('screens.catalog.search.placeholder')}
        </span>
      </button>
    </div>
  )
}

export default SearchButton
